import { Container, Typography, Box } from "@mui/material";
import UnauthorizedBase from "../../../Base/views/UnauthorizedBase";

const DeleteAccountStepPage = () => {
  return (
    <UnauthorizedBase>
      <Box
        sx={{
          maxHeight: "calc(100vh - 80px)",
          overflowY: "auto",
          overflowX: "hidden",
          width: "100%",
        }}
      >
        <Container maxWidth="md" sx={{ py: 5 }}>
          <Typography variant="h3" gutterBottom>
            Account Deletion Policy
          </Typography>

          <Box mt={4}>
            <Typography paragraph>
              This page explains how account deletion works for users of the{" "}
              <strong>Meepl</strong> mobile application.
            </Typography>
          </Box>

          <Box mt={4}>
            <Typography variant="h5">Who Controls Your Data</Typography>
            <Typography paragraph>
              Meepl is a Software-as-a-Service (SaaS) platform provided to
              organizations.
            </Typography>
            <Typography paragraph>
              All employee accounts and associated data are created, managed and
              owned by the respective organization (your employer or HR Admin). Meepl acts only as a <strong>data processor</strong>, while
              your organization is the <strong>data controller</strong>.
            </Typography>
          </Box>

          <Box mt={4}>
            <Typography variant="h5">How to Request Account Deletion</Typography>
            <Typography paragraph>
              If you wish to delete your account or personal data, you must
              contact your organization directly:
            </Typography>
            <Typography paragraph>
              - Reach out to your HR Admin
              <br />
              - Submit a request as per your organization’s internal process
            </Typography>
            <Typography paragraph>
              Meepl does <strong>not process direct account deletion requests</strong>{" "}
              from individual users.
            </Typography>
          </Box>

          <Box mt={4}>
            <Typography variant="h5">How Deletion is Processed</Typography>
            <Typography paragraph>
              - Your organization reviews and approves deletion requests
              <br />
              - Once approved, the organization may delete or deactivate your
              account using MEEPL’s administrative controls
              <br />
              - Meepl processes such actions only based on instructions from the
              authorized organization
            </Typography>
          </Box>

          <Box mt={4}>
            <Typography variant="h5">What Happens After Deletion</Typography>
            <Typography paragraph>
              Upon deletion initiated by your organization:
              <br />
              - Your access to the application will be revoked
              <br />
              - Your account and associated personal data will be removed or
              anonymized as per system capabilities
            </Typography>
          </Box>

          <Box mt={4}>
            <Typography variant="h5">Data Retention</Typography>
            <Typography paragraph>
              Certain information may be retained by your organization or within
              Meepl systems for a limited period if required for:
              <br />
              - Legal or statutory compliance
              <br />
              - Audit requirements
              <br />
              - Organizational policies
            </Typography>
          </Box>

          <Box mt={4}>
            <Typography variant="h5">Contact Information</Typography>
            <Typography paragraph>
              For any account-related concerns, please contact your organization’s
              administrator or HR team.
            </Typography>
            <Typography paragraph>
              If your organization requires assistance, they may reach out to
              Meepl support through official channels.
            </Typography>
          </Box>
        </Container>
      </Box>
    </UnauthorizedBase>
  );
};

export default DeleteAccountStepPage;